import React, {Component} from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import {Accordion, Table, Icon, Checkbox} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import '../invoicing.scss';

class Item extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'activeIndex': 0,
    };
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e, titleProps) {
    const {activeIndex} = this.state;
    const {index} = titleProps;
    const newIndex = activeIndex === index ? -1 : index;
    this.setState({'activeIndex': newIndex});
  }

  onOrderCodeItemCheckboxChange(orderCode, event, value) {
    event.stopPropagation();
    if (value.checked) {
      this.props.addOrderCodeToInvoice(orderCode);
      return;
    }

    this.props.removeOrderCodeToInvoice(orderCode);
  }

  renderItems() {
    const {item} = this.props;

    return item.detail.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center' className='part-code-column'>
            {element.partCode}
          </Table.Cell>
          <Table.Cell textAlign='center' className='description-column'>
            {element.partName}
          </Table.Cell>
          <Table.Cell textAlign='center'>{element.quantity}</Table.Cell>
          <Table.Cell textAlign='right'>
            {'$'}
            {element.price.toFixed(2)}
          </Table.Cell>
          <Table.Cell textAlign='right'>
            {'$'}
            {element.subtotal.toFixed(2)}
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  render() {
    const {activeIndex} = this.state;
    const {item, index, invoicing} = this.props;

    return (
      <Accordion fluid>
        <Accordion.Title
          index={index}
          active={activeIndex === index}
          onClick={this.handleClick}
        >
          <Table striped className='toyota-grid'>
            <Table.Body>
              <Table.Row className={`${item.checked ? 'checked' : ''}`}>
                <Table.Cell textAlign='left' className='checkbox-column'>
                  <Checkbox
                    id={`order-code-${index}`}
                    label={`Pedido ${item.code}`}
                    disabled={invoicing}
                    defaultChecked={item.checked}
                    onChange={() =>
                      this.onOrderCodeItemCheckboxChange(item.code)
                    }
                  />
                </Table.Cell>
                <Table.Cell textAlign='left' className='quantity-column'>
                  Total de items: {_.sumBy(item.detail, 'quantity')}
                </Table.Cell>
                <Table.Cell textAlign='left' className='subtotal-column'>
                  Valor Total: {'$'}
                  {_.sumBy(item.detail, 'subtotal').toFixed(2)}
                </Table.Cell>
                <Table.Cell textAlign='right'>
                  <Icon name='dropdown' />
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Accordion.Title>

        <Accordion.Content active={activeIndex === index}>
          <Table striped className='toyota-grid'>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign='center'>
                  Cod Parte
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>
                  Descripción
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>
                  Cantidad Requerida
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>
                  Precio de Venta
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Subtotal</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>{this.renderItems()}</Table.Body>
          </Table>
        </Accordion.Content>
      </Accordion>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    'invoicing': state.invoicing.invoicing,
  };
};

const {
  addOrderCodeToInvoice,
  removeOrderCodeToInvoice,
} = Actions;

export default connect(mapStateToProps, {
  addOrderCodeToInvoice,
  removeOrderCodeToInvoice,
})(Item);
